import { Injectable } from '@angular/core';
import {
  Effect,
  Actions,
  ofType
} from '@ngrx/effects';
import {
  map,
  filter,
  distinctUntilChanged
} from 'rxjs/operators';
import {
  SetConfig,
  ConfigActionTypes
} from './config.actions';
import { Title } from '@angular/platform-browser';
import { AppConfigLoaded } from '../life-cycle/life-cycle.actions';

@Injectable({
  providedIn: 'root'
})
export class ConfigEffects {

  @Effect({ dispatch: false, resubscribeOnError: true })
  public setAppName$ = this.actions$.pipe(
    ofType<SetConfig>(ConfigActionTypes.SetConfig),
    filter(action => action.config && !!action.config.appName),
    map(action => action.config.appName),
    distinctUntilChanged(),
    map(appName => this.titleService.setTitle(appName))
  );

  @Effect()
  public configLoaded$ = this.actions$.pipe(
    ofType<SetConfig>(ConfigActionTypes.SetConfig),
    filter(action => !!action.config),
    map(() => new AppConfigLoaded()),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly titleService: Title,
  ) {}
}
